module.exports = __webpack_public_path__ + "static/img/bg.ff92220b.png";